import { render, staticRenderFns } from "./BodyOverlay.vue?vue&type=template&id=68182b1f&"
import script from "./BodyOverlay.vue?vue&type=script&lang=ts&"
export * from "./BodyOverlay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports